import { Box, Stack } from '@mui/material';
import { designTokens, type ResolvedBrandTheme } from '../../../design-system';

/** 같은 화면 구도로 색상 세트의 전체 인상을 비교하는 장식용 썸네일입니다. */
export function AppearanceThemeThumbnail({ palette }: { palette: ResolvedBrandTheme }) {
  return (
    <Box aria-hidden sx={{ overflow: 'hidden', bgcolor: palette.pageCanvasColor, border: '1px solid', borderColor: palette.dividerColor, borderRadius: designTokens.shape.md }}>
      <Stack direction="row" sx={{ height: 13, px: 0.75, alignItems: 'center', gap: 0.5, bgcolor: designTokens.color.canvas, borderBottom: '1px solid', borderColor: palette.dividerColor }}>
        <Box sx={{ width: 5, height: 5, borderRadius: designTokens.shape.xs, bgcolor: palette.actionColor }} />
        <Box sx={{ width: 22, height: 3, borderRadius: designTokens.radius.pill, bgcolor: palette.dividerColor }} />
      </Stack>
      <Box sx={{ display: 'grid', gridTemplateColumns: '24px minmax(0, 1fr)', height: 42 }}>
        <Stack spacing={0.5} sx={{ p: 0.5, bgcolor: palette.navigationSurfaceColor }}>
          <Box sx={{ height: 7, borderRadius: designTokens.shape.xs, bgcolor: palette.navigationSelectedSurfaceColor }} />
          {[0, 1, 2].map((item) => <Box key={item} sx={{ width: 9, height: 2, bgcolor: palette.navigationTextColor, opacity: 0.4, borderRadius: designTokens.radius.pill }} />)}
        </Stack>
        <Stack spacing={0.5} sx={{ p: 0.5 }}>
          <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ width: 24, height: 4, borderRadius: designTokens.radius.pill, bgcolor: designTokens.color.secondaryText }} />
            <Box sx={{ width: 17, height: 7, borderRadius: designTokens.radius.pill, bgcolor: palette.actionColor }} />
          </Stack>
          <Stack spacing={0.5} sx={{ p: 0.375, borderRadius: designTokens.shape.sm, bgcolor: designTokens.color.canvas, border: '1px solid', borderColor: palette.dividerColor }}>
            {[0, 1].map((item) => <Stack key={item} direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
              <Box sx={{ width: 6, height: 6, flexShrink: 0, borderRadius: designTokens.radius.circle, bgcolor: palette.accentSoftColor, border: '1px solid', borderColor: palette.accentColor }} />
              <Box sx={{ width: item === 0 ? '50%' : '38%', height: 3, borderRadius: designTokens.radius.pill, bgcolor: palette.dividerColor }} />
            </Stack>)}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
